import * as Y from 'yjs';

import { AnswerStyleType } from 'shared/types/AnswerStyleType';
import { WidgetType } from 'shared/widgets/utils';

import { manifestLocales } from './manifest.locales';
import { createNewSelectionQuestionAnswerData } from '@/contentObjects/SelectionQuestionAnswer/create';
import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { Feedbacks } from '@/utils/feedback.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { DEFAULT_ANSWERS_AMOUNT, defaultAnswerConfig } from '@/widgets/SelectionQuestion/consts';
import { getEvaluationProps } from '@/widgets/consts/getEvaluationProps';
import { createQuestionWidgetChildren } from '@/widgets/utils/createQuestionWidgetChildren';
import { initializeAnswers } from '@/widgets/utils/initializeAnswers';

export function createNewSelectionQuestionData(options: InitializePropsOptions): ManifestInitializedProps {
  const { isPlenaryLesson, locale } = options;
  const { initialHeadlineText } = manifestLocales.multiChoice;

  const id = genRandId();
  const labelFragment = htmlToXmlFragment(`<h2><span>${initialHeadlineText[locale]}</span></h2>`);
  const hintFragment = htmlToXmlFragment('<p></p>');
  const answers = initializeAnswers(defaultAnswerConfig, DEFAULT_ANSWERS_AMOUNT);
  const widgetEvaluationProps = Object.entries(getEvaluationProps(isPlenaryLesson));

  const [questionAnswerData] = createNewSelectionQuestionAnswerData();
  const { childrenArray, horizontalFlexSectionData, verticalFlexSectionData } = createQuestionWidgetChildren(
    questionAnswerData.id,
    options?.width
  );

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.SelectionQuestion],
        ['children', childrenArray],
        ['labelFragment', labelFragment],
        ['hintFragment', hintFragment],
        ['answers', answers],
        ['amountOfColumns', 1],
        ['answerElements', ['Text']],
        ['withRandomAnswers', false],
        ['isSingleAnswerQuestion', false],
        ['feedback', Feedbacks.Check],
        ['answersStyle', AnswerStyleType.Default],
        ['saveAnswers', true],
        ...widgetEvaluationProps,
        ['questionAnswerId', questionAnswerData.id]
      ]),
      sensitiveData: new Y.Map([['correctAnswers', []]])
    },
    verticalFlexSectionData,
    horizontalFlexSectionData,
    questionAnswerData
  ];
}
